import { motion } from 'framer-motion';
import { LuX } from 'react-icons/lu';
import styled from 'styled-components';

export const BackgroundModal = styled(motion.div)`
    width: 100%;
    height: 100%;

    background: rgb(0, 0, 0, 0.6);
    position: fixed;
    z-index: 999;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    /* padding-top: 6rem; */

    @media (max-width: 768px) {
        padding-top: 0;
    }

    backdrop-filter: blur(2px);
`;

export const ModalWrapper = styled.div`
    max-width: 40rem;
    width: 100%;

    overflow-y: auto;
    box-shadow: 0 0.3125rem 1rem rgba(0, 0, 0, 0.2);
    background: ${({ theme }) => theme.colors.primary};
    color: #000;
    position: relative;
    z-index: 10001;
    border-radius: 1.25rem;
    clip-path: inset(0 round 1.25rem);
    padding: 1.5rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: content-box;

    p {
        font-weight: 600;
        padding-bottom: 1rem;
        font-size: 1.25rem;
    }

    @media (max-width: 1400px) {
        max-width: 40rem;
    }
`;

export const ModalTitleClose = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;

    p {
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.5rem;
        color: ${({ theme }) => theme.colors['neutral-900']};
    }
`;

export const ModalContent = styled.div`
    color: ${({ theme }) => theme.colors['neutral-900']};
    /* height: 75vh; */

    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.5rem;

    display: flex;
    flex-direction: column;
    /* padding: 1.5rem; */
    align-items: center;
    /* overflow-x: clip; */
    justify-content: space-evenly;
    gap: 1.5rem;

    p {
        margin-bottom: 1rem;
        line-height: 1.5rem;
    }
`;

export const CloseModalButton = styled(LuX)`
    cursor: pointer;
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    width: 1.25rem;
    height: 1.25rem;
    padding: 0;
    z-index: 10;
    z-index: 10001;
`;

export const GiftsModalForm = styled.div`
    display: flex;
    flex-direction: column;

    gap: 1.5rem;
    width: 100%;
    height: fit-content;

    .gifts-column {
        display: flex;
        flex-direction: column;
        border-radius: 0.75rem;
        /* gap: 0.5rem; */
        /* overflow: hidden; */
        max-height: 30rem;
        overflow-y: auto;
        width: 100%;
        /* padding: 0 .25rem; */

        & > .installment-option {
            display: flex;
            /* gap: 0.75rem; */
            /* padding: 0.75rem; */
            align-items: center;

            input {
                /* height: 1rem; */
                aspect-ratio: 1/1;
            }
        }

        label {
            display: flex;
            width: 100%;
            cursor: pointer;
            align-items: center;

            p {
                display: flex;
                align-items: center;
                margin: 2px 0;
                justify-content: space-between;
                width: 100%;
            }
        }

        span {
            display: flex;
            margin-left: auto;
            font-weight: 500;
            margin-left: auto;
            font-size: 1rem;
            opacity: 0.75;
        }

        & > .installment-option:nth-child(odd) {
            background: var(--Neutral-100, #f4f4f5);
        }
    }

    P {
        padding: 0 !important;
    }

    .buttons-wrapper {
        display: flex;
        flex-grow: 1;
        width: 100%;
        gap: 1.5rem;
        button {
            width: 50%;
        }
    }
`;
